import { render, staticRenderFns } from "./tags-column.vue?vue&type=template&id=1d8bebd1"
import script from "./tags-column.vue?vue&type=script&lang=js"
export * from "./tags-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d8bebd1')) {
      api.createRecord('1d8bebd1', component.options)
    } else {
      api.reload('1d8bebd1', component.options)
    }
    module.hot.accept("./tags-column.vue?vue&type=template&id=1d8bebd1", function () {
      api.rerender('1d8bebd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/approved-message/columns/tags-column.vue"
export default component.exports